import { Fragment, type ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';

/** Reset identity-scoped state synchronously without reloading the document or theme. */
export function AuthoritySessionBoundary({ children }: { children: ReactNode }) {
  const { user, authorityVersion, isDemoMode } = useAuth();
  const sessionKey = JSON.stringify([
    isDemoMode,
    user?.id,
    user?.account_role,
    user?.platform_role,
    user?.workspace_id,
    authorityVersion,
  ]);

  // A key (not an effect) prevents a previous persona's providers, route guards,
  // overlays or pending component state from surviving an authority transition.
  return <Fragment key={sessionKey}>{children}</Fragment>;
}
